import { useField } from 'remix-validated-form'
import { useEffect, useState } from 'react'
import { stripHtml } from 'string-strip-html'

interface CheckboxInputProps {
  label?: string
  labelClass?: string
  id?: string
  name: string
  checked?: boolean
  disabled?: boolean
  optional?: boolean
  onChange?: (checked: boolean) => void
}

export default function CheckboxInput(props: CheckboxInputProps) {
  const { error } = useField(props.name)
  const defaultChecked = props.checked ? props.checked : false
  const [isChecked, setIsChecked] = useState(defaultChecked)

  return (
    <>
      <div className="flex select-none items-start gap-2">
        <input
          className="mt-0.5"
          type="checkbox"
          key={props.id}
          id={props.id}
          name={props.name}
          value="true"
          checked={isChecked}
          disabled={props.disabled}
          onChange={() => {
            setIsChecked((prev) => !prev)
            props.onChange?.(!isChecked)
          }}
        />
        {props.label && (
          <label
            className={`${props.labelClass ?? 'text-sm text-brand-gray-700 prose-a:border-b prose-a:border-brand-primary-500'}`}
            htmlFor={props.id}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: stripHtml(props.label, { ignoreTags: ['a'] }).result,
              }}
            />
            {!props.optional && <span className="asterisk" />}
          </label>
        )}
      </div>

      {error && <span className="text-sm text-danger-500">{error}</span>}
    </>
  )
}
